import { render, staticRenderFns } from "./SingleSoundSelectorParameterType.vue?vue&type=template&id=a1037cb2&"
import script from "./SingleSoundSelectorParameterType.vue?vue&type=script&lang=js&"
export * from "./SingleSoundSelectorParameterType.vue?vue&type=script&lang=js&"
import style0 from "./SingleSoundSelectorParameterType.vue?vue&type=style&index=0&id=a1037cb2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports